import * as shadowCss from 'bundle-text:./dist/widget/index.css';
import ReactDOM from 'react-dom/client';
import KiaPage from './src/App';
import { ImageTypeEnum } from './src/components/carousel/types/CarouselTypes';
import { ThemeEnum } from './src/pages/newsletter/newsletter';

class KiaWidget extends HTMLElement {
  private root: ReactDOM.Root | null = null;

  connectedCallback() {
    const shadow = this.attachShadow({ mode: 'closed' });

    const container = document.createElement('div');
    container.id = 'kia-page';
    shadow.appendChild(container);

    const sheet = new CSSStyleSheet();
    sheet.replaceSync(shadowCss);
    shadow.adoptedStyleSheets = [sheet];

    const fonts = [
      new FontFace(
        'kiam',
        'url(https://kia-afonso-storage.b-cdn.net/fonts/DesignKB.woff2) format("woff2")',
        { style: 'normal', weight: '700' },
      ),
      new FontFace(
        'kiam',
        'url(https://kia-afonso-storage.b-cdn.net/fonts/DesignKL.woff2) format("woff2")',
        { style: 'normal', weight: '400' },
      ),
      new FontFace(
        'kiam',
        'url(https://kia-afonso-storage.b-cdn.net/fonts/DesignKM.woff2) format("woff2")',
        { style: 'normal', weight: '300' },
      ),
    ];
    Promise.all(fonts.map((font) => font.load()))
      .then((loadedFonts) => {
        loadedFonts.forEach((loadedFont) => {
          document.fonts.add(loadedFont);
        });
      })
      .catch((error) => {
        console.error('Error loading fonts:', error);
      });

    const fontSheet = new CSSStyleSheet();
    fontSheet.replaceSync(`
      :host {
        --srem: 16px;
        font-family: kiam;
      }
    `);

    shadow.adoptedStyleSheets = [fontSheet, sheet];

    this.root = ReactDOM.createRoot(container);
    this.renderReact();
  }

  attributeChangedCallback() {
    this.renderReact();
  }

  disconnectedCallback() {
    this.root?.unmount();
  }

  private getAttributes(widgetAttributes: NamedNodeMap) {
    const attributes: Record<string, string | boolean> = {};

    Array.from(widgetAttributes).forEach((attr) => {
      const name = attr.name;
      const value = attr.value;
      attributes[name] = value === '' ? true : value;
    });

    return {
      kiaPage: attributes['kia-page'] as string,
      heading: attributes['heading'] as string,
      category: attributes['category'] as string,
      tag: attributes['tag'] as string,
      imageType: attributes['image-type'] as ImageTypeEnum,
      fields: attributes['fields'] as string,
      fuelId: attributes['fuel-id'] as string,
      categoryIds: attributes['category-ids'] as string,
      pricelist: attributes['pricelist'] as boolean,
      theme: attributes['theme'] as ThemeEnum,
      pdfName: attributes['pdf-name'] as string,
      description: attributes['description'] as string,
      buttonLabel: attributes['button-label'] as string,
      checkboxLabel: attributes['checkbox-label'] as string,
      emailPlaceholder: attributes['email-placeholder'] as string,
      thankYouMessage: attributes['thank-you-message'] as string,
      modelCode: attributes['model-code'] as string,
      trimCodes: attributes['trim-codes'] as string,
      modelCodes: attributes['model-codes'] as string,
      ids: attributes['ids'] as string,
      privateMileages: attributes['private-mileages'] as string,
      activeTrims: attributes['active-trims'] as string,
      availableTrims: attributes['available-trims'] as string,
      compact: attributes['compact'] as boolean,
    };
  }
  private renderReact() {
    if (!this.root) return;
    const props = this.getAttributes(this.attributes);
    if (!props.kiaPage) {
      this.root.render(<div>Please provide a 'page' attribute.</div>);
      return;
    }
    this.root.render(<KiaPage {...props} />);
  }
}

customElements.define('kia-widget', KiaWidget);
